// Slovak formatters

export function fmtEur(n) {
  if (n == null || isNaN(Number(n))) return '0,00 €';
  const num = Number(n);
  const sign = num < 0 ? '-' : '';
  const abs = Math.abs(num);
  const [int, dec = '00'] = abs.toFixed(2).split('.');
  const intSp = int.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  return `${sign}${intSp},${dec} €`;
}

export function fmtNum(n, decimals = 2) {
  if (n == null || isNaN(Number(n))) return '0';
  const num = Number(n);
  const [int, dec = ''] = num.toFixed(decimals).split('.');
  const intSp = int.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  return decimals > 0 ? `${intSp},${dec}` : intSp;
}

export function fmtDate(iso) {
  if (!iso) return '';
  const d = new Date(iso);
  if (isNaN(d.getTime())) return '';
  return `${d.getDate()}. ${d.getMonth() + 1}. ${d.getFullYear()}`;
}

export function fmtDateShort(iso) {
  if (!iso) return '';
  const d = new Date(iso);
  if (isNaN(d.getTime())) return '';
  return `${d.getDate()}. ${d.getMonth() + 1}.`;
}

export function toIsoDate(d = new Date()) {
  const dt = d instanceof Date ? d : new Date(d);
  return dt.toISOString().slice(0, 10);
}

export function parseSkDate(s) {
  // Accepts "30. 4. 2026" or "30.4.2026"
  if (!s) return null;
  const m = s.match(/^(\d{1,2})\.\s?(\d{1,2})\.\s?(\d{4})$/);
  if (!m) return null;
  const [, day, month, year] = m;
  const d = new Date(Number(year), Number(month) - 1, Number(day));
  return isNaN(d.getTime()) ? null : d;
}

export function addDays(date, days) {
  const d = new Date(date);
  d.setDate(d.getDate() + days);
  return d;
}

export function quarterOf(date) {
  const d = new Date(date);
  return Math.floor(d.getMonth() / 3) + 1;
}

export function isOverdue(invoice) {
  if (!invoice || invoice.status === 'paid' || invoice.status === 'cancelled') return false;
  if (!invoice.due_date) return false;
  return new Date(invoice.due_date) < new Date(new Date().toDateString());
}
